import { UPDATE_QUANTITY_INPUT, HIGHLIGHT_QUANTITY_INPUT, RESET_QUANTITY_INPUT } from '../constants';

const defaultState = {
    quantityFields: {}
};

export const quantityInput = (
    state = defaultState,
    action
) => {
    switch (action.type) {
        case RESET_QUANTITY_INPUT: 
        return {
            ...state,
            quantityFields: {}
        };
        case UPDATE_QUANTITY_INPUT: 
            return {
                ...state,
                quantityFields: {
                    ...state.quantityFields,
                    [action.payload.quantityFieldId] : action.payload,
                }
            };
        case HIGHLIGHT_QUANTITY_INPUT: 
            return {
                ...state,
                quantityFields: {
                    ...state.quantityFields,
                    [action.payload] : {...state.quantityFields[action.payload], highlight: Date.now()},
                }
            };
        default:
            return state;
    }
};
